var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showContent)?_c('section',{staticClass:"mt-2"},[_c('div',{staticClass:"bodytext text-break",domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }